export const background = '#212D40';
export const primary = '#D66853';
export const secondary = '#FFFFFF';
export const tertiary = '#7D4E57';
export const border = "#364156"